module.exports = __webpack_public_path__ + "img/新闻顶部图.059fa75c.png";